import React from "react"

import { Row, Col, Card } from "react-bootstrap"

function Nearby({ property }) {
    return (
        <>
            <Col xs={12} as={Card} className="mt-5 mt-lg-7">
                {/* Nearby Amenities */}
                <Card.Body>
                    <Card.Title>
                        <h2 className="text-center">Nearby</h2>
                    </Card.Title>
                </Card.Body>
            </Col>
            <Col xs={12} as={Card} className="mt-4">
                {/* Nearby Amenities */}
                <Card.Body>
                    {/* Nearby Train Stations */}
                    <Card.Text as={Row}>
                        <h3 className="h6">Train stations</h3>
                        {property.location?.nearby_train_stations.map(
                            (train_station) => (
                                <Row key={train_station.id}>
                                    <Col xs={12} className="mb-3">
                                        <ul className="nearby-train">
                                            <li className="nearby-train">
                                                <span>
                                                    {train_station.name}
                                                </span>
                                                <span className="ms-2 text-wjlightgrey">
                                                    {train_station.distance.toFixed(
                                                        1,
                                                    )}
                                                    mi
                                                </span>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            ),
                        )}
                        {/* Nearby Train Stations End */}

                        {/* Nearby Bus Stations */}
                        <h3 className="h6 mt-2">Bus stations</h3>
                        {property.location?.nearby_bus_stations
                            .slice(0, 2)
                            .map((bus_station) => (
                                <Row key={bus_station.id}>
                                    <Col xs={12} className="mb-3">
                                        <ul className="nearby-bus">
                                            <li className="nearby-bus">
                                                <span>{bus_station.name}</span>
                                                <span className="ms-2 text-wjlightgrey ">
                                                    {bus_station.distance.toFixed(
                                                        1,
                                                    )}
                                                    mi
                                                </span>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            ))}
                        {/* Nearby Bus Stations End */}

                        {/* Nearby Pharmacies */}
                        <h3 className="h6 mt-2">Pharmacies</h3>
                        {property.location?.nearby_pharmacies.map(
                            (pharmacy) => (
                                <Row key={pharmacy.id}>
                                    <Col xs={12} className="mb-3">
                                        <ul className="nearby-pharmacy">
                                            <li className="nearby-pharmacy">
                                                <span>{pharmacy.name}</span>
                                                <span className="ms-2 text-wjlightgrey">
                                                    {pharmacy.distance.toFixed(
                                                        1,
                                                    )}
                                                    mi
                                                </span>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            ),
                        )}
                        {/* Nearby Pharmacies End */}
                        <span className="text-wjlightgrey">
                            These distances are calculated in a straight line,
                            actual distances may vary.
                        </span>
                    </Card.Text>
                </Card.Body>
                {/* Nearby Amenities End */}
            </Col>
        </>
    )
}

export default Nearby
